'use client';
import './previewSliderTheme.scss';

import { ThemeContext } from '@susu/custom-made/providers';
import { Section } from '@susu/custom-made/utils/navigation';
import { useContext, useEffect, useRef } from 'react';
import Slider from 'react-slick';

export default function PreviewSlider({
  sliderTogoIndex,
  children,
}: Readonly<{
  sliderTogoIndex: number | null;
  children: React.ReactNode[];
}>) {
  const sliderRef = useRef<Slider | null>(null);
  const { state } = useContext(ThemeContext);

  useEffect(() => {
    if (sliderTogoIndex !== null) {
      sliderRef.current?.slickGoTo(sliderTogoIndex);
    }
  }, [sliderTogoIndex]);

  return (
    <div className="preview-slider-container">
      <div className="slider-container">
        <Slider
          dots={!state.isPreviewZoomed && state.section === Section.Fabric}
          infinite={false}
          slidesToShow={1}
          slidesToScroll={1}
          adaptiveHeight={false}
          arrows={state.isPreviewZoomed || state.section !== Section.Fabric ? false : children.length > 1}
          swipe={false}
          ref={slider => {
            sliderRef.current = slider;
          }}
        >
          {children.map((child, key) => {
            return (
              <div className="slide-image-container" key={key}>
                {child}
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
}
